import React from "react";
import styled from "styled-components";
import { Link } from "gatsby";
import { siteWidth } from "../common/variables";
import Logo from "../../images/svg/logo-brand.svg";
import { mainNavy, screen } from "../common/variables";

const Wrapper = styled.nav`
  width: 100%;
  max-width: ${siteWidth};
  top: 0;
  z-index: 50;
  box-shadow: 0 4px 4px -2px rgba(0, 0, 0, 0.15);
  background: ${mainNavy};
  padding: 27px 0;

  .inner-wrapper {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 32px;
    @media ${screen.xsmall} {
      padding: 0 25px;
    }
    @media ${screen.medium} {
      padding: 0;
    }

    .logo {
      svg {
        width: 100%;
        max-width: 70px;
        @media ${screen.xsmall} {
          max-width: 90px;
        }
        @media ${screen.small} {
          max-width: 90px;
        }
      }
    }
  }
`;

const Nav = () => {
  return (
    <Wrapper>
      <div className="inner-wrapper">
        <div className="logo">
          <Link to="/">
            <Logo />
          </Link>
        </div>
      </div>
    </Wrapper>
  );
};

export default Nav;
